<template>
    <div>
        <Bar :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId" :dataset-id-key="datasetIdKey"
            :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width" :height="height" />
    </div>
</template>
<script>
import { Bar } from 'vue-chartjs/legacy'
// import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
import { mapState } from "vuex";

export default {
    name: 'LabourCostGraph',
    components: {
        Bar
    },
    props: {
        chartId: {
            type: String,
            default: 'bar-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => { }
        },
        plugins: {
            type: Array,
            default: () => []
        },
        dayWiseData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            scheduleData: [],
            deficitData: [],
            dayWiseDataCopy: [],
            transactionDataCopy: [],
            maxData: 0,
            stepSize: 0,
            chartData: {
                labels: [],
                datasets: []
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    mode: 'index',
                    intersect: false,
                    titleFontSize: 10,
                    bodyFontSize: 12,
                    titleSpacing: 7,
                    bodySpacing: 7,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return data.datasets[tooltipItem.datasetIndex].label + ': ' + tooltipItem.yLabel;
                        }
                    }
                },
                // stacked graph
                scales: {
                    xAxes: [{
                        offset: true,
                        ticks: {
                            display: true
                        },
                        gridLines: {
                            color: "rgba(221, 221, 221, 1)",
                            drawBorder: true,
                        },
                    }],
                    yAxes: [
                        {
                            id: 'barChart',
                            ticks: {
                                display: true,
                            },
                            gridLines: {
                                display: true
                            },
                            type: 'linear',
                            position: 'left',
                            color: '#e29d5a'
                        },
                        {
                            id: 'lineChart',
                            ticks: {
                                display: true,
                            },
                            gridLines: {
                                display: false
                            },
                            type: 'linear',
                            position: 'right',
                            color: '#e29d5a'
                        },
                    ],
                },
                plugins: {
                    datalabels: {
                        anchor: function (context) {
                            return 'end';
                        },
                        align: function (context) {
                            return 'end';
                        },
                        padding: 6,
                        // backgroundColor: function(context) {
                        //     return context.dataset.label === 'Deficit' ? '#f87979' : '';
                        // },
                        // color: function(context) {
                        //     return context.dataset.label === 'Deficit' ? '#fff' : '#000';
                        // },
                        borderRadius: 4,
                        formatter: Math.round,
                        font: {
                            weight: 'bold'
                        },
                        // Show only deficit label values and not a negative value or zero
                        display: function (context) {
                            return false;
                        },
                        clamp: true,
                    }
                },
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        usePointStyle: true,
                        boxWidth: 10,
                        padding: 20,
                        fontSize: 12,
                        fontColor: '#000',
                        fontFamily: 'sans-serif',
                        fontStyle: 'normal',
                    }
                },
            },
        }
    },

    computed: {
        ...mapState("CommonStore", ["reportLoader", "labourData_store", "isLabourDataSHow", "labourCostDataType", "labourColData_store"]),
        isLabourDataShows() {
            return this.isLabourDataSHow;
        },
        isTableLoading() {
            return this.reportLoader;
        },
        labourCostData() {
            let data = [...this.labourData_store];
            if (['monthly', 'daily', 'weekly'].includes(this.labourCostDataType)) {
                data = this.labourColData_store;
            }
            return data;
        },
        labourCostDate() {
            let data = [...this.labourData_store];
            let result = []
            data.map((elm) => {
                result.push(elm.for_date);
            });
            result = _.uniq(result);
            return result;
        },
    },

    watch: {
        labourCostData: {
            handler(val) {
                // First set the dataset 
                if (this.isLabourDataShows == 'labour_cost') {
                    if (['monthly', 'daily', 'weekly'].includes(this.labourCostDataType)) {
                        this.chartData.labels = this.labourCostDate;
                        this.chartData.datasets = [
                            { label: 'Scheduled Labour Cost', backgroundColor: '#e29d5a', type: 'bar', data: [], },
                            { label: 'Actual Labour Cost', backgroundColor: '#f9cb9c', type: 'bar', data: [], }
                        ];
                    } else {
                        this.chartData.datasets = [
                            { label: 'Sales', backgroundColor: '#e29d5a', type: 'bar', data: [], },
                            { label: 'Scheduled Labour Cost', backgroundColor: '#f9cb9c', yAxisID: 'barChart', type: 'bar', data: [], },
                            { label: 'Actual Labour Cost', backgroundColor: '#fce5cd', type: 'bar', data: [], },
                            { label: 'Sch COL(%)', backgroundColor: '#ffffff00', yAxisID: 'lineChart', type: 'line', data: [], order: 1, pointRadius: 5, pointHoverRadius: 10, pointBorderWidth: 2, borderColor: '#011627' },
                            { label: 'Act COL(%)', backgroundColor: '#ffffff00', yAxisID: 'lineChart', type: 'line', data: [], order: 1, pointRadius: 5, pointHoverRadius: 10, pointBorderWidth: 2, borderColor: '#247BA0' }
                        ];
                    }
                } else if (this.isLabourDataShows == 'labour_hour') {
                    if (['monthly', 'daily', 'weekly'].includes(this.labourCostDataType)) {
                        this.chartData.labels = this.labourCostDate; 
                    } 
                    this.chartData.datasets = [
                        { label: 'Actual Labour Hrs', backgroundColor: '#e29d5a', type: 'bar', data: [], },
                        { label: 'Scheduled Labour Hrs', backgroundColor: '#f9cb9c', yAxisID: 'barChart', type: 'bar', data: [], },
                        { label: 'VTS', backgroundColor: '#ffffff00', yAxisID: 'lineChart', type: 'line', data: [], order: 1, pointRadius: 5, pointHoverRadius: 10, pointBorderWidth: 2, borderColor: '#247BA0' }
                    ];
                }

                val.map((e) => {
                    if (this.isLabourDataShows == 'labour_cost') {

                        if (['monthly', 'daily', 'weekly'].includes(this.labourCostDataType)) {

                            // Added data to data points 
                            this.chartData.datasets.map((elm) => {
                                if (elm.label == "Scheduled Labour Cost") {
                                    elm.data.push(e.scheduled_lc);
                                }
                                if (elm.label == "Actual Labour Cost") {
                                    elm.data.push(e.scheduled_lc);
                                }
                            })
                        } else  {
                            let stores = [];
                            let sales = [];
                            let schedule_lc = [];
                            let actual_lcs = [];
                            let sch_lc_percent = [];
                            let actual_lc_percent = [];

                            val.map((e) => {
                                stores.push(e.name.toUpperCase());
                                sales.push(e.actual_sales);
                                schedule_lc.push(e.scheduled_lc);
                                actual_lcs.push(e.actual_lc);
                                sch_lc_percent.push(e.sch_lc_act_sales_percentage);
                                actual_lc_percent.push(e.actual_lc_percentage);
                            });

                            this.chartData.labels = stores;
                            this.chartData.datasets[0].data = sales;
                            this.chartData.datasets[1].data = schedule_lc;
                            this.chartData.datasets[2].data = actual_lcs;
                            this.chartData.datasets[3].data = sch_lc_percent;
                            this.chartData.datasets[4].data = actual_lc_percent;
                        } 

                    } else if (this.isLabourDataShows == 'labour_hour') {

                        if (['monthly', 'daily', 'weekly'].includes(this.labourCostDataType)) { 
                            // Added data to data points 
                            this.chartData.datasets.map((elm) => {
                                if (elm.label == "Scheduled Labour Hrs") {
                                    elm.data.push(e.scheduled_hours);
                                }
                                if (elm.label == "Actual Labour Hrs") {
                                    elm.data.push(e.actual_hours);
                                }
                                if (elm.label == "VTS") {
                                    elm.data.push(e.vts);
                                }
                            });
                        } else {
                             // Added data to data points 
                             this.chartData.datasets.map((elm) => {
                                if (elm.label == "Scheduled Labour Hrs") {
                                    elm.data.push(e.scheduled_hours);
                                }
                                if (elm.label == "Actual Labour Hrs") {
                                    elm.data.push(e.actual_hours);
                                }
                            });

                            let stores = [];
                            let actual = [];
                            let scheduled = [];
                            let vts = [];

                            val.map((e) => {
                                stores.push(e.name.toUpperCase());
                                actual.push(e.actual_hours);
                                scheduled.push(e.scheduled_hours);
                                vts.push(e.vts);
                            });

                            this.chartData.labels = stores;
                            this.chartData.datasets[0].data = actual;
                            this.chartData.datasets[1].data = scheduled;
                            this.chartData.datasets[2].data = vts;
                        }
                    }
                });
            },
            deep: true,
        }
    },

    mounted() {

    },
    methods: {

    },
}
</script>
